import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import {
  agendarManutencao,
  resetManutencaoState,
} from "../../../features/manutencao/slices";
import { actionGetPontosMonitoriaByLoja } from "../../../features/monitoramento/lista-pontos/slices";
import BaseLayout from "../../../components/Layout";
import Input from "../../../components/Inputs";
import Button from "../../../components/Button";
import { getUser } from "../../../helpers/user";
import { useAppSelector } from "../../../hooks/useAppSelector";
import "./styles.scss";

const AMBIENTE_VALIDACAO_NOME = "AMBIENTE DE VALIDAÇÃO";

const OPCOES_SIM_NAO_FORMALIZACAO = [
  "SIM (COM FORMALIZAÇÃO)",
  "SIM (SEM FORMALIZAÇÃO)",
  "NÃO",
];

const OPCOES_DESCRICAO_INTERRUPCAO = [
  "VGA FECHADA",
  "INDISPONIBILIDADE DE ÁGUA",
  "SPRINKLER INOPERANTE",
  "ALARME DE INCÊNDIO DESATIVADO",
  "SISTEMA DE DETECÇÃO DESATIVADO",
  "BOMBA DE INCÊNDIO INOPERANTE",
  "ESVAZIAMENTO DE RESERVATÓRIO",
  "OUTROS (INFORMAR AO LADO)",
];

const OPCOES_TIPO_MANUTENCAO = [
  "MANUTENÇÃO PROGRAMADA",
  "MANUTENÇÃO EMERGENCIAL",
];

const DIAS_SEMANA = [
  { value: 0, label: "Dom" },
  { value: 1, label: "Seg" },
  { value: 2, label: "Ter" },
  { value: 3, label: "Qua" },
  { value: 4, label: "Qui" },
  { value: 5, label: "Sex" },
  { value: 6, label: "Sáb" },
];

const PERGUNTAS_ACAO_GERENCIA_LOCAL: { key: string; label: string }[] = [
  {
    key: "corpoBombeirosNotificado",
    label: "O Corpo de Bombeiros foi notificado?",
  },
  {
    key: "extintoresAdicionaisDisponiveis",
    label: "Há extintores adicionais disponíveis na área sem proteção?",
  },
  {
    key: "vigilanciaInspecionandoArea",
    label: "Há vigilância inspecionando a área sem proteção?",
  },
  {
    key: "areaMonitoradaDeteccaoCalorFumaca",
    label:
      "A área sem proteção é monitorada por sistema de detecção de calor/fumaça?",
  },
  {
    key: "sistemaDeteccaoMonitorado",
    label: "Sistema de detecção da área é monitorado?",
  },
  {
    key: "hidrantesDisponiveisArea",
    label: "Há hidrantes disponíveis na área em manutenção?",
  },
  {
    key: "operacoesRiscoInterrompidas",
    label:
      "Operações de risco foram interrompidas? (ex.: solda, maçarico, lixadeira)",
  },
  {
    key: "brigadaEmergenciaNotificada",
    label: "A brigada de emergência foi notificada?",
  },
];

const PageAgendamentoManutencao = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { status, error } = useSelector((state: RootState) => state.manutencao);

  const [idLoja, setIdLoja] = useState<string>("");
  const [horarioInicio, setHorarioInicio] = useState<string>("");
  const [horarioFim, setHorarioFim] = useState<string>("");
  const [observacao, setObservacao] = useState<string>("");
  const [recorrente, setRecorrente] = useState(false);
  const [diasRecorrencia, setDiasRecorrencia] = useState<number[]>([]);

  const [numeroApolice, setNumeroApolice] = useState<string>("");
  const [descricaoInterrupcao, setDescricaoInterrupcao] = useState<string>("");
  const [outrosDescricaoInterrupcao, setOutrosDescricaoInterrupcao] =
    useState<string>("");
  const [tipoManutencao, setTipoManutencao] = useState<string>("");
  const [descricaoParadaLocaisAfetados, setDescricaoParadaLocaisAfetados] =
    useState<string>("");
  const [informacoesAdicionais, setInformacoesAdicionais] =
    useState<string>("");
  const [acaoGerenciaLocal, setAcaoGerenciaLocal] = useState<
    Record<string, string>
  >({});
  const [acaoGerenciaLocalOutros, setAcaoGerenciaLocalOutros] =
    useState<string>("");

  const [selectedPontosIds, setSelectedPontosIds] = useState<number[]>([]);

  const idUsuarioCriador = 1;

  const user = getUser();
  const userNivel = Number(user?.usuario?.nivel ?? 0);
  const podeVerAmbienteValidacao = userNivel >= 9;
  const nomeUsuario = user?.usuario?.nome ?? "";

  const [email, setEmail] = useState<string>(user?.usuario?.email ?? "");
  const [telefone, setTelefone] = useState<string>(
    user?.usuario?.contato ?? "",
  );

  const todasLojas = useAppSelector((state) => state.getLojas.lojas || []);
  const lojaSelected =
    useAppSelector((state) => state.getLojas.lojaSelected) || "";

  const temLojaSelecionadaNoAside = Boolean(lojaSelected);

  console.log(
    "temLojaSelecionadaNoAside:",
    temLojaSelecionadaNoAside,
    "lojaSelected:",
    lojaSelected,
  );

  const idLojaEfetivo = temLojaSelecionadaNoAside
    ? String(lojaSelected)
    : idLoja;

  console.log("idLojaEfetivo:", idLojaEfetivo);

  const lojaObjetoSelected = useAppSelector((state) => {
    const lista = state.getLojas.lojas || [];
    return lista.find((l: any) => l.id === Number(idLojaEfetivo));
  }) as any;

  const lojasVisiveis = useMemo(() => {
    return todasLojas.filter((loja: any) => {
      if (podeVerAmbienteValidacao) return true;
      return loja?.nome?.trim().toUpperCase() !== AMBIENTE_VALIDACAO_NOME;
    });
  }, [todasLojas, podeVerAmbienteValidacao]);

  const clienteFormatado = lojaObjetoSelected?.nome
    ? `${lojaObjetoSelected.nome} - ${nomeUsuario}`
    : "";
  const enderecoLoja = lojaObjetoSelected?.endereco ?? "";

  const pontosMonitoriaByLoja = useSelector(
    (state: RootState) => state.pontosMonitoriaByLoja,
  );

  useEffect(() => {
    if (!idLojaEfetivo) return;

    dispatch(actionGetPontosMonitoriaByLoja(idLojaEfetivo));
  }, [dispatch, idLojaEfetivo]);

  useEffect(() => {
    setSelectedPontosIds([]);
  }, [idLojaEfetivo]);

  const listaPontosDaLoja = useMemo(() => {
    const grupos = pontosMonitoriaByLoja?.data?.grupoMonitor;
    if (!grupos || !Array.isArray(grupos)) return [];

    const todosPontos = grupos
      .map((item: any) => [
        ...(item.listaMonA || []),
        ...(item.listaMonD || []),
        ...(item.listaMonR || []),
      ])
      .flat();

    const pontosUnicos = new Map<number, any>();
    for (const ponto of todosPontos) {
      if (!pontosUnicos.has(ponto.id)) {
        pontosUnicos.set(ponto.id, ponto);
      }
    }

    return Array.from(pontosUnicos.values());
  }, [pontosMonitoriaByLoja]);

  const todosPontosSelecionados =
    listaPontosDaLoja.length > 0 &&
    selectedPontosIds.length === listaPontosDaLoja.length;

  const handleTogglePonto = (id: number) => {
    setSelectedPontosIds((prev) =>
      prev.includes(id) ? prev.filter((p) => p !== id) : [...prev, id],
    );
  };

  const handleToggleDiaRecorrencia = (dia: number) => {
    setDiasRecorrencia((prev) =>
      prev.includes(dia) ? prev.filter((d) => d !== dia) : [...prev, dia],
    );
  };

  const handleToggleSelecionarTodosPontos = () => {
    setSelectedPontosIds(
      todosPontosSelecionados ? [] : listaPontosDaLoja.map((p: any) => p.id),
    );
  };

  const handleAcaoGerenciaLocalChange = (key: string, value: string) => {
    setAcaoGerenciaLocal((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!idLojaEfetivo || !horarioInicio || !horarioFim) {
      return;
    }

    if (recorrente && diasRecorrencia.length === 0) {
      return;
    }

    dispatch(
      agendarManutencao({
        idLoja: Number(idLojaEfetivo),
        idsPontosSelecionados: selectedPontosIds,
        horarioInicio,
        horarioFim,
        idUsuarioCriador,
        observacao,

        cliente: clienteFormatado,
        endereco: enderecoLoja,
        numeroApolice,
        email,
        telefone,
        descricaoInterrupcao,
        outrosDescricaoInterrupcao:
          descricaoInterrupcao === "OUTROS (INFORMAR AO LADO)"
            ? outrosDescricaoInterrupcao
            : "",
        tipoManutencao,
        descricaoParadaLocaisAfetados,
        acaoGerenciaLocalJson: JSON.stringify(acaoGerenciaLocal),
        acaoGerenciaLocalOutros,
        informacoesAdicionais,
        recorrente,
        diasRecorrencia: recorrente ? diasRecorrencia : undefined,
      }),
    );
  };

  useEffect(() => {
    if (status === "success") {
      setIdLoja("");
      setHorarioInicio("");
      setHorarioFim("");
      setObservacao("");
      setNumeroApolice("");
      setDescricaoInterrupcao("");
      setOutrosDescricaoInterrupcao("");
      setTipoManutencao("");
      setDescricaoParadaLocaisAfetados("");
      setInformacoesAdicionais("");
      setAcaoGerenciaLocal({});
      setAcaoGerenciaLocalOutros("");
      setSelectedPontosIds([]);
      setRecorrente(false);
      setDiasRecorrencia([]);
      dispatch(resetManutencaoState());
    }
  }, [status, dispatch]);

  const isLoading = status === "loading";

  return (
    <BaseLayout>
      <div className="maintenance-container">
        <div className="maintenance-card">
          <h2 className="maintenance-card__title">
            Agendar Janela de Manutenção Programada
          </h2>
          <p className="maintenance-card__description">
            {temLojaSelecionadaNoAside
              ? "A loja selecionada no menu lateral será usada. Marque abaixo os pontos de monitoramento específicos, se desejar."
              : "Selecione a loja e, se quiser, marque os pontos de monitoramento específicos abaixo."}{" "}
            Deixe todos desmarcados caso deseje desativar temporariamente as
            notificações de falha para a <strong>Loja inteira</strong>.
          </p>

          <form className="maintenance-form" onSubmit={handleSubmit}>
            {/* ---------------------------------------------------------------- */}
            {/* LOJA — segue o mesmo padrão do wizard de instalação:              */}
            {/* já selecionada no aside -> somente leitura; senão -> select       */}
            {/* ---------------------------------------------------------------- */}
            <div className="form-grid">
              <div className="input-wrapper field-large">
                <label className="label label--sm">Loja *</label>
                {temLojaSelecionadaNoAside ? (
                  <input
                    type="text"
                    disabled
                    placeholder="Preenchido automaticamente pela seleção do menu lateral"
                    value={lojaObjetoSelected?.nome ?? ""}
                  />
                ) : (
                  <select
                    title="Selecione a Loja"
                    value={idLoja}
                    onChange={(e) => setIdLoja(e.target.value)}
                    disabled={isLoading}
                    required
                  >
                    <option value="">Selecione uma loja...</option>
                    {lojasVisiveis.map((loja: any) => (
                      <option key={loja.id} value={loja.id}>
                        {loja.nome}
                      </option>
                    ))}
                  </select>
                )}
              </div>
            </div>

            {/* ---------------------------------------------------------------- */}
            {/* PONTOS DE MONITORAMENTO DA LOJA (checkbox) */}
            {/* ---------------------------------------------------------------- */}
            {idLojaEfetivo && (
              <div
                className="form-group pontos-monitoramento"
                style={{ borderTop: "1px solid #f1f5f9" }}
              >
                <div className="pontos-monitoramento__head">
                  <label className="label label--sm" style={{ margin: 0 }}>
                    Pontos de Monitoramento
                  </label>

                  {listaPontosDaLoja.length > 0 && (
                    <label className="pontos-monitoramento__select-all">
                      <input
                        type="checkbox"
                        checked={todosPontosSelecionados}
                        onChange={handleToggleSelecionarTodosPontos}
                        disabled={isLoading}
                      />
                      Selecionar todos
                    </label>
                  )}
                </div>

                {listaPontosDaLoja.length === 0 ? (
                  <p className="paragraph paragraph--sm pontos-monitoramento__empty">
                    Nenhum ponto de monitoramento encontrado para esta loja.
                  </p>
                ) : (
                  <div className="pontos-monitoramento__list">
                    {listaPontosDaLoja.map((item: any) => {
                      const checked = selectedPontosIds.includes(item.id);
                      return (
                        <label
                          key={item.id}
                          className={`ponto-item${checked ? " ponto-item--checked" : ""}`}
                        >
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={() => handleTogglePonto(item.id)}
                            disabled={isLoading}
                          />
                          <span className="ponto-item__dot" />
                          <span className="ponto-item__label">
                            {item.equipamento?.nome}
                            {item.sequenciaItem ? ` ${item.sequenciaItem}` : ""}
                            <span className="ponto-item__code">
                              {item.idCentral}-{item.adrModulo}-{item.idEntrada}
                              {item.equipamento?.tipo} · {item.modeloModulo}
                            </span>
                          </span>
                        </label>
                      );
                    })}
                  </div>
                )}
              </div>
            )}

            {/* ---------------------------------------------------------------- */}
            {/* CLIENTE / ENDEREÇO — preenchidos automaticamente pela Loja */}
            {/* ---------------------------------------------------------------- */}
            <div
              className="form-grid"
              style={{ borderTop: "1px solid #f1f5f9" }}
            >
              <div className="input-wrapper field-large">
                <label className="label label--sm">Cliente</label>
                <input
                  type="text"
                  value={clienteFormatado}
                  disabled
                  placeholder="Preenchido automaticamente ao selecionar a loja"
                />
              </div>
              <div className="input-wrapper field-large">
                <label className="label label--sm">Endereço</label>
                <input
                  type="text"
                  value={enderecoLoja}
                  disabled
                  placeholder="Preenchido automaticamente ao selecionar a loja"
                />
              </div>
            </div>

            {/* ---------------------------------------------------------------- */}
            {/* CONTATO / APÓLICE */}
            {/* ---------------------------------------------------------------- */}
            <div className="form-grid">
              <Input
                type="text"
                name="numeroApolice"
                label="Nº Apólice"
                size="sm"
                value={numeroApolice}
                onChange={(e: any) => setNumeroApolice(e.currentTarget.value)}
                disabled={isLoading}
              />
              <Input
                type="email"
                name="email"
                label="E-mail"
                size="sm"
                value={email}
                onChange={(e: any) => setEmail(e.currentTarget.value)}
                disabled={isLoading}
              />
            </div>

            <div className="form-grid">
              <Input
                type="text"
                name="telefone"
                label="Telefone"
                size="sm"
                value={telefone}
                onChange={(e: any) => setTelefone(e.currentTarget.value)}
                disabled={isLoading}
              />
              <div className="hide-on-mobile" />
            </div>

            {/* ---------------------------------------------------------------- */}
            {/* DESCRIÇÃO DA INTERRUPÇÃO / TIPO DE MANUTENÇÃO */}
            {/* ---------------------------------------------------------------- */}
            <div
              className="form-grid"
              style={{ borderTop: "1px solid #f1f5f9" }}
            >
              <div className="input-wrapper">
                <label className="label label--sm">
                  Descrição da Interrupção
                </label>
                <select
                  title="Selecione a descrição da interrupção"
                  value={descricaoInterrupcao}
                  onChange={(e) => setDescricaoInterrupcao(e.target.value)}
                  disabled={isLoading}
                >
                  <option value="">Escolher um item.</option>
                  {OPCOES_DESCRICAO_INTERRUPCAO.map((opcao) => (
                    <option key={opcao} value={opcao}>
                      {opcao}
                    </option>
                  ))}
                </select>
              </div>

              <div className="input-wrapper">
                <label className="label label--sm">Tipo de Manutenção</label>
                <select
                  title="Selecione o tipo de manutenção"
                  value={tipoManutencao}
                  onChange={(e) => setTipoManutencao(e.target.value)}
                  disabled={isLoading}
                >
                  <option value="">Escolher um item.</option>
                  {OPCOES_TIPO_MANUTENCAO.map((opcao) => (
                    <option key={opcao} value={opcao}>
                      {opcao}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {descricaoInterrupcao === "OUTROS (INFORMAR AO LADO)" && (
              <div className="form-grid">
                <Input
                  type="text"
                  name="outrosDescricaoInterrupcao"
                  label="Informe a interrupção (Outros)"
                  size="sm"
                  value={outrosDescricaoInterrupcao}
                  onChange={(e: any) =>
                    setOutrosDescricaoInterrupcao(e.currentTarget.value)
                  }
                  disabled={isLoading}
                />
                <div className="hide-on-mobile" />
              </div>
            )}

            {/* ---------------------------------------------------------------- */}
            {/* HORÁRIOS */}
            {/* ---------------------------------------------------------------- */}
            <div
              className="form-grid"
              style={{ borderTop: "1px solid #f1f5f9" }}
            >
              <Input
                type="datetime-local"
                name="horarioInicio"
                label="Horário de Início *"
                size="sm"
                value={horarioInicio}
                onChange={(e: any) => setHorarioInicio(e.currentTarget.value)}
                disabled={isLoading}
                required
              />

              <Input
                type="datetime-local"
                name="horarioFim"
                label="Horário de Fim *"
                size="sm"
                value={horarioFim}
                onChange={(e: any) => setHorarioFim(e.currentTarget.value)}
                disabled={isLoading}
                required
              />
            </div>

            {/* ---------------------------------------------------------------- */}
            {/* RECORRÊNCIA */}
            {/* ---------------------------------------------------------------- */}
            <div
              className="form-group"
              style={{ borderTop: "1px solid #f1f5f9" }}
            >
              <label className="pontos-monitoramento__select-all">
                <input
                  type="checkbox"
                  checked={recorrente}
                  onChange={(e) => {
                    setRecorrente(e.target.checked);
                    if (!e.target.checked) setDiasRecorrencia([]);
                  }}
                  disabled={isLoading}
                />
                Manutenção recorrente
              </label>

              {recorrente && (
                <div style={{ marginTop: "10px" }}>
                  <label
                    className="label label--sm"
                    style={{ marginBottom: "6px" }}
                  >
                    Dias da semana em que ocorre *
                  </label>
                  <div
                    style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}
                  >
                    {DIAS_SEMANA.map((dia) => {
                      const checked = diasRecorrencia.includes(dia.value);
                      return (
                        <label
                          key={dia.value}
                          className={`ponto-item${checked ? " ponto-item--checked" : ""}`}
                          style={{ padding: "4px 10px" }}
                        >
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={() =>
                              handleToggleDiaRecorrencia(dia.value)
                            }
                            disabled={isLoading}
                          />
                          {dia.label}
                        </label>
                      );
                    })}
                  </div>
                  {diasRecorrencia.length === 0 && (
                    <p
                      className="paragraph paragraph--sm"
                      style={{ color: "#dc2626", marginTop: "6px" }}
                    >
                      Selecione ao menos um dia.
                    </p>
                  )}
                </div>
              )}
            </div>

            {/* ---------------------------------------------------------------- */}
            {/* DESCRIÇÃO DA PARADA E LOCAIS AFETADOS */}
            {/* ---------------------------------------------------------------- */}
            <div
              className="form-group"
              style={{ borderTop: "1px solid #f1f5f9" }}
            >
              <label className="label label--sm">
                Descrição da Parada e Locais Afetados
              </label>
              <textarea
                value={descricaoParadaLocaisAfetados}
                onChange={(e) =>
                  setDescricaoParadaLocaisAfetados(e.target.value)
                }
                rows={3}
                placeholder="Descreva a parada e os locais/áreas afetadas..."
                disabled={isLoading}
              />
            </div>

            {/* ---------------------------------------------------------------- */}
            {/* AÇÃO TOMADA PELA GERÊNCIA LOCAL */}
            {/* ---------------------------------------------------------------- */}
            <div
              className="form-group"
              style={{ borderTop: "1px solid #f1f5f9" }}
            >
              <label
                className="label label--sm"
                style={{ marginBottom: "10px", display: "block" }}
              >
                Ação Tomada pela Gerência Local
              </label>

              {PERGUNTAS_ACAO_GERENCIA_LOCAL.map((pergunta, index) => (
                <div key={pergunta.key} className="question-row">
                  <span className="question-row__number">{index + 1}</span>
                  <span className="question-row__label">{pergunta.label}</span>
                  <div className="question-row__control">
                    <select
                      title={pergunta.label}
                      value={acaoGerenciaLocal[pergunta.key] ?? ""}
                      onChange={(e) =>
                        handleAcaoGerenciaLocalChange(
                          pergunta.key,
                          e.target.value,
                        )
                      }
                      disabled={isLoading}
                    >
                      <option value="">Escolher um item.</option>
                      {OPCOES_SIM_NAO_FORMALIZACAO.map((opcao) => (
                        <option key={opcao} value={opcao}>
                          {opcao}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              ))}

              <div className="question-row">
                <span className="question-row__number">9</span>
                <span className="question-row__label">Outros</span>
                <div className="question-row__control">
                  <input
                    type="text"
                    value={acaoGerenciaLocalOutros}
                    onChange={(e) => setAcaoGerenciaLocalOutros(e.target.value)}
                    placeholder="Informe, se houver"
                    disabled={isLoading}
                  />
                </div>
              </div>
            </div>

            {/* ---------------------------------------------------------------- */}
            {/* INFORMAÇÕES ADICIONAIS */}
            {/* ---------------------------------------------------------------- */}
            <div
              className="form-group"
              style={{ borderTop: "1px solid #f1f5f9" }}
            >
              <label className="label label--sm">Informações Adicionais</label>
              <textarea
                value={informacoesAdicionais}
                onChange={(e) => setInformacoesAdicionais(e.target.value)}
                rows={3}
                placeholder="Outras informações relevantes..."
                disabled={isLoading}
              />
            </div>

            {/* ---------------------------------------------------------------- */}
            {/* MOTIVO / OBSERVAÇÃO (campo original da tela) */}
            {/* ---------------------------------------------------------------- */}
            <div
              className="form-group"
              style={{ borderTop: "1px solid #f1f5f9" }}
            >
              <label className="label label--sm">Motivo / Observação</label>
              <textarea
                value={observacao}
                onChange={(e) => setObservacao(e.target.value)}
                rows={3}
                placeholder="Descreva o motivo técnico da intervenção..."
                disabled={isLoading}
              />
            </div>

            {error && <div className="maintenance-form__error">{error}</div>}

            <Button
              size="sm"
              type="submit"
              variant="primary"
              loading={isLoading}
              disabled={isLoading}
            >
              {isLoading ? "Salvando..." : "Salvar Agendamento"}
            </Button>
          </form>
        </div>
      </div>
    </BaseLayout>
  );
};

export default PageAgendamentoManutencao;
